import React from "react";
import {Card, CardActions, CardContent} from "@material-ui/core";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Toast, ToastBody, Button,} from 'reactstrap';

import SignatureCanvas from 'react-signature-canvas';

/**
 *  @property {Forms_Completion_Object} state
 *  @property {object} model
 *  @property {Forms_Completion_Properties} model.properties
 *  @property {Forms_Completion_Is} model.is
 *  @property {Forms_Completion_Has} model.has
 */

const setSigPadWidth = () => {
	let scrollbarWidth = 17; //Based on Google Chrome, can detect different browsers if necessary
	let viewportWidth = window.innerWidth - scrollbarWidth;
	const styledPaddingAndPositioning = ((15+14+40)*2)
	//15px: .container-fluid | 14px: .MuiCardContent_root |
	//40px: .signature (this is left/right positioning, and includes a second .MuiCardContent_root)

	let breakpointXsmSmCalc = () => viewportWidth - styledPaddingAndPositioning;
	let breakpointMdCalc = () => viewportWidth*0.7 - styledPaddingAndPositioning;
	let breakpointLgXlgCalc = () => (viewportWidth*0.7 - 15*2 - 14*2)*0.7 - 40*2;
	return window.innerWidth < 769 ? breakpointXsmSmCalc()
		: window.innerWidth < 992 ? breakpointMdCalc()
			: breakpointLgXlgCalc();
}

export default class MandatoryAntiVirusInspectionWaiver extends Framework.Components.Object{
	constructor(props) {
		super(props, Types.Forms_Av_Inspection._name );
	}

	componentDidMount(){
		if(this.props.passedObject){
			this.setState(this.props.passedObject);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Forms_Completion_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name);
		}
	}

	/** @type Object */
	sigPad1 = null;
	clear = (sigPad) => {
		this[sigPad].clear();
	};

	getSigPad1Ref = (ref) => {
		if (!ref) return;
		this.sigPad1 = ref;
	}

	clearSigPad1Ref = () => this.clear('sigPad1')


	loadSelfAfter(){
		this.setState({warranty:false})
	}

	async handleSubmit(event, suppressToast = false) {
		if ( this.sigPad1.getCanvas() !== null) {
			this.state.signature = this.sigPad1.getCanvas().toDataURL('image/png');
		}
		this.state.name = this.state.name.trim();

		let posting = false;
		if(this.state.name !== '' && this.state.fresh_desk !== ''){
			posting = true;
		}
		await super.handleSubmit();
		if(posting){
			this.props.passedObject.post ? window.location.href = this.props.passedObject.post : ''
		}
	}

	render(){
		/** @type {Forms_Completion_Properties} object */
		let {properties} = this.model;
		/** @type {Forms_Completion_Object} object */
		let object = this.state;
		let isNew = !this.state.pkey || this.state.pkey === '0';
		let disabled = object.signature && (this.props.id || this.props.id==="0")

		let sigCanvasDims = {width: setSigPadWidth(), height:300 };
		return(
			<Card>
				<CardContent>
					<Toast style={{maxWidth:"100%"}} className={"bg-warning"}>
						<ToastBody className={"text-center"}>
							<h5>WARNING: REFUSAL OF ANTI-VIRUS SCAN IS EXTREMELY DANGEROUS</h5>
							<p>Karls Technology Anti Virus Inspection Waiver</p>
						</ToastBody>
					</Toast>
					{/*#region Information*/}
					<h4 className="section-title mdl-typography--text-center">
						Anti Virus Inspection Waiver
					</h4>

					<div className={"row"} >
						<div className={"col"}>
							<p>
							1. Acknowledgement of Refusal: I, the undersigned, acknowledge that I am refusing the recommended industry-standard procedure of performing a complete anti-virus and malware inspection prior to service of my computer. I understand that this refusal exposes my device and all stored data to infection, corruption, ransomware, spyware, and other malicious software. I further understand that Karls Technology strongly advises this inspection as an industry standard process to protect my system and data.
							</p>
							<p>
							2. Assumption of Risk: I understand and accept that by refusing this anti-virus inspection, I am assuming full responsibility for all risks associated with malware, viruses, or other infections, including loss, corruption, or permanent destruction of files, applications, or operating system functionality. I understand that these risks may result in irreversible data loss or critical system failure.
							</p>
							<p>
							3. Release of Liability: I hereby unconditionally release, waive, and forever discharge Karls Technology, its employees, agents, representatives, managers, subsidiaries, assigns, and affiliates from any and all claims, demands, or causes of action arising from or relating to my refusal of the anti-virus inspection. I understand that no claim of any kind, now or in the future, can be brought against Karls Technology for malware infections, data loss, or system damage resulting from this refusal.
							</p>
							<p>
							4. Waiver of Warranty: I understand and acknowledge that by refusing this anti-virus inspection, I irrevocably void any and all warranties, guarantees, or assurances regarding the services provided by Karls Technology. I further acknowledge that no return visits, free warranty repairs, or remedial service will be provided under any circumstances for any issues arising from malware or virus infection after service. This waiver is final, binding, and applies to all future claims related to this service.
							</p>
							<p>
							5. Acknowledgement of Understanding: I acknowledge that I have read and fully understand this waiver, and that my refusal of the anti-virus inspection is a decision with potentially catastrophic consequences. By signing below, I confirm that I voluntarily accept all risks, assume full responsibility, and waive all rights to hold Karls Technology liable for any resulting infections, data loss, or system failure.
							</p>
						</div>
					</div>

					{/*#endregion*/}
					<fieldset disabled={!!disabled}>
						<h4 className="section-title">Information Needed</h4>
						<div className={"row"}>
							<div className={"col-md"}>
								<div className={'form-group'}>
									<Framework.Elements.TextField
										label={"Name"}
										value={object.name}
										error={object.name_error}
										property={properties.name}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>

							<div className={"col-md"}>
								<div className={'form-group'}>
									<Framework.Elements.TextField
										label={"Freshdesk Number"}
										value={object.fresh_desk}
										error={object.fresh_desk_error}
										property={properties.fresh_desk}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>

						<h4 className="section-title"> Signature</h4>
						<div>
							<div className={'row signature-row'} >
								<div className={'col-12'}>
									<div className="mdl-typography--text-center">
										<Card>
											<CardContent className="OnePage positionRelative">
												<span className={'signature'}/>
												{object.signature ? <img src={object.signature} alt={'Signature'}/> :
													<div style={{backgroundColor: '#f2f3f4'}}>
													<SignatureCanvas penColor='black' canvasProps={Object.assign({className: 'sigCanvas'}, sigCanvasDims)}
													                 ref={this.getSigPad1Ref}/></div>}
											</CardContent>
											{!object.signature?<CardActions className="OnePage signatureClearButtonContainer">
												<Button color="secondary" onClick={this.clearSigPad1Ref}>Clear</Button>
											</CardActions>:null}
										</Card>
									</div>
								</div>
							</div>
						</div>
					</fieldset>

				</CardContent>
				<CardActions>
					<Button color="primary" onClick={this.handleSubmit}>
						{isNew ? 'Submit' : 'Save'}
					</Button>
				</CardActions>
			</Card>
		)
	}
}
